import styled from "styled-components";

export const StyledHamburgerMenuList = styled.div`
    margin-top: 32px;

    .minusIcon {
        svg {
            width: 16px;
        }
    }

    .plusIcon {
        svg {
            width: 17px;
            height: 17px;

            path {
                fill: var(--color-secondary);
            }
        }
    }

    .accordion-root {
        background-color: transparent;
        box-shadow: none;

        .accordion-summary-root {
            padding-left: 0;

            .accordion-summary-content {
                padding-bottom: 8px;
                /* border-bottom: 1px solid var(--color-grey-500); MYBR-6930 */
            }
        }

        &::before {
            content: none;
        }

        &.accordion-expanded {
            .accordion-summary-content {
                margin: 12px 0;
            }
        }

        .accordionInfo {
            display: flex;

            svg {
                margin-right: 10px;
            }

            span {
                font-size: var(--size-14);
                line-height: 21px;
                color: var(--color-grey-900);
            }
        }

        .accordion-details-root {
            flex-direction: column;
            padding: 0 0 0 45px;

            .details-wrapper {
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 10px 0 10px 0;
                cursor: pointer;
                /* border-bottom: 1px solid var(--color-grey-500); MYBR-6930 */

                &.disabled {
                    position: relative;
                    pointer-events: none;
                    cursor: default;
                    opacity: 0.5;
                }

                &.disabled::before {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    pointer-events: auto;
                    content: "";
                }

                span {
                    font-size: var(--size-12);
                    line-height: 21px;
                    color: var(--color-grey-900);
                }

                .checkMark {
                    width: 18px;
                }
            }
        }
    }
`;
